import { PageHeader } from '@/components/shared/PageHeader';
import { useMarketplaceChain } from '@/hooks/use-marketplace-chain';
import { useAuthentication } from '@/hooks/useAuthentication';
import { routes } from '@/utils/routes';
import { compareAddresses, formatAddress } from '@onbeam/utils';
import useTranslation from 'next-translate/useTranslation';
import { type FC } from 'react';

type Props = {
  address: string;
  displayName?: string;
};

export const AccountBreadcrumbs: FC<Props> = ({ address, displayName }) => {
  const { t } = useTranslation('account');
  const { userAddress } = useAuthentication();
  const isOwner = compareAddresses(userAddress, address);
  const marketplaceChain = useMarketplaceChain();

  return (
    <>
      <PageHeader
        pages={[
          {
            name: t('crumbs.home'),
            href: routes.home(marketplaceChain.routePrefix),
          },
          {
            name: isOwner ? t('crumbs.your-profile') : displayName || formatAddress(address),
            href: routes.profile(address, marketplaceChain.routePrefix),
          },
        ]}
        pb={{ base: 'space.12', md: 'space.32' }}
        containerVariant="breakout"
      />
    </>
  );
};
